import axios from 'axios'

import config from '../config'

const reqClient = axios.create({
  baseURL: config.api.root
})

export default reqClient
